import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_URL = API_BASE_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, setToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processGoogleAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error('Authentication failed - no session ID');
          navigate('/login', { replace: true });
          return;
        }

        // Exchange session_id for user data
        const response = await axios.post(`${API_URL}/api/auth/google/session`, {
          session_id: sessionId
        }, {
          withCredentials: true
        });

        const { access_token, user } = response.data;

        // Store token and user
        localStorage.setItem('token', access_token);
        setToken(access_token);
        setUser(user);

        toast.success(`Welcome, ${user.name}!`);

        // Check if user has quote progress
        const hasQuoteProgress = localStorage.getItem('quoteProgress');
        if (hasQuoteProgress) {
          navigate('/quote', { replace: true, state: { user } });
        } else {
          navigate('/dashboard', { replace: true, state: { user } });
        }

      } catch (error) {
        console.error('Google auth error:', error);
        toast.error(error.response?.data?.detail || 'Authentication failed');
        navigate('/login', { replace: true });
      }
    };

    processGoogleAuth();
  }, [navigate, setUser, setToken]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4 text-primary" />
        <p className="text-muted-foreground">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
